import * as React from 'react';
import b_ from 'b_';
import cn from 'classnames';
import './styles.scss';

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  title?: string;
  subtitle?: React.ReactNode;
  control?: React.ReactNode;
  icon?: React.ReactNode;
}

const b = b_.with('search-not-found');

export const GenericInfoContainer: React.FC<Props> = ({
  title,
  subtitle,
  control,
  icon,
  className,
  ...attrs
}) => {
  return (
    <div className={cn(b('container'), className)} {...attrs}>
      {icon && <div className={b('icon')}>{icon}</div>}

      {title && <span className={b('title')}>{title}</span>}
      {subtitle && <span className={b('subtitle')}>{subtitle}</span>}
      {control && <div className={b('control')}>{control}</div>}
    </div>
  );
};
